import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    btnClose: {

        position: 'absolute',
        right: '5px',
        top: '3px'

    },
}